module.exports = __webpack_public_path__ + "static/meshkat-complete-6dc0ce468d443f334940c2436e897d0f.jpg";